const initState = {
  allMarkers: null,
};

const markerReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_MARKERS_DATA":
      return {
        ...state,
        allMarkers: action.payload, // Corrected typo
      };

    default:
      return state; // No need to create a new object for default case
  }
};

export default markerReducer;
